import { Subject, Observable, of, from, Subscription } from 'rxjs';
import { map,tap } from 'rxjs/operators';


import { Vasat } from 'vasat';
import { FourDService } from '../4d-mapper.service';
import { Account, Folder,Dataset, TransformType, Transform, PlottableModel, Annotation, TransformGroup} from '../4d-objects';
import { MapHelper } from '../4d-helper';
import { FourdCesiumHelper } from '../cesium-helpers';
import {  Renderer,PlottableReference } from '../renderer'
var Cesium = window['Cesium']

export class BlankAnnotationRenderer extends Renderer<Annotation>{
	constructor(private cesium:FourdCesiumHelper){
		super()
		if(!Cesium) Cesium = window['Cesium']

	}
	onAdd(p: Annotation,args?:any): Observable<PlottableReference> {
	
		// console.log('##annot');

	   var caption = {
			showBackground : true,
			fourd_ref: p.id,
			font : '14px monospace',
			horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
			verticalOrigin :Cesium.VerticalOrigin.BOTTOM,
			//heightReference:p.lheight?Cesium.HeightReference.NONE:Cesium.HeightReference.CLAMP_TO_GROUND
		}


		caption = this.cesium.annotationLabels.add(caption)

		var ref = {
			object:caption,
			plottable:p
		}
		return of(ref)
	}	
	onUpdate(p: Annotation, pr: PlottableReference,args?:any): Observable<PlottableReference>{
		pr.object.position = p.catresian()
		pr.object.name = p.name
		pr.object.text = p.name 
		if(args){
			Object.keys(args).forEach(k => pr.object[k] = args[k])
		}
		return of(pr)
	}
	onRemove(obj: Annotation, pr: PlottableReference): Observable<PlottableReference> {
	
		if(pr.object.label)
			this.cesium.annotationLabels.remove(pr.object.label)

		return of(null)
	}
}
export class LegacyAnnotationRenderer extends Renderer<Annotation>{
	constructor(private cesium:FourdCesiumHelper){
		super()
		if(!Cesium) Cesium = window['Cesium']

	}
	onAdd(p: Annotation,args?:any): Observable<PlottableReference> {
		var pin = {
			position: p.catresian(),
			name: p.name,
			text: p.name,
			fourd_ref:p.id,
			font : '14px monospace',
			horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
			verticalOrigin : Cesium.VerticalOrigin.TOP,
			disableDepthTestDistance : 20,
			billboard : {
				heightReference:p.lheight?Cesium.HeightReference.NONE:Cesium.HeightReference.CLAMP_TO_GROUND,
				image : null,
				verticalOrigin : Cesium.VerticalOrigin.BOTTOM,
				disableDepthTestDistance:Number.POSITIVE_INFINITY
			}
		}

		var caption = {
			position:p.catresian(),
			name:p.name,
			text:p.name,
			showBackground : true,
			fourd_ref: p.id,
			font : '14px monospace',
			horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
			verticalOrigin :Cesium.VerticalOrigin.TOP,
			disableDepthTestDistance : 20
		}
			
		if(!p.style || !p.style.hidePin)
			pin = this.cesium.annotationDataSource.entities.add(pin)
		if(p.style && p.style.caption)
			caption = this.cesium.annotationLabels.add(caption)

		var ref = {
			object:{
				pin:!p.style || !p.style.hidePin?pin:null,
				label:p.style && p.style.caption?caption:null
			},
			plottable:p
		}
		// if theres a byo style function
		if(args && args.styleFunction)
			args.styleFunction(ref)

		// console.log('##pin',pin);
		
		return of(ref)
	}	
	onRemove(obj: Annotation, pr: PlottableReference): Observable<PlottableReference> {
	
		if(pr.object.pin)
			this.cesium.annotationDataSource.entities.remove(pr.object.pin)
		if(pr.object.label)
			this.cesium.annotationLabels.remove(pr.object.label)

		return of(null)
	}


}


